(function () {
    'use strict';

    angular
        .module("skillsApp")
        .filter('dateOfExpiryTrainingItem', dateOfExpiryTrainingItem);

    function dateOfExpiryTrainingItem($filter, $translate) {
        var dateFilter = $filter('date');

        return function (value, item) {
            if (item && item.dateOfExpiry) {
                return dateFilter(item.dateOfExpiry, 'dd-MM-yyyy');
            }

            return $translate.instant('not_yet_finalized');
        };
    }
})();
